import { Component, OnInit } from '@angular/core';
import { DataService } from '../../providers/data.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {

  pages = [];
  active_page: any;
  new_page = {body: "<h1>NEW PAGE TITLE</h1><p>Please add some text here ...</p>", icon: "information-circle-outline", name: "new_page", order: 0, settings: {}, status: "NEW", title: "new page"};
  page_states = [
    {label: 'New page (not visible yet)', value: 'NEW'},
    {label: 'Published page', value: 'AVAILABLE'},
    {label: 'Archived page', value: 'NOT_AVAILABLE'},
    {label: 'Contact page (max 1)', value: 'CONTACT'}
  ];

  page_icons = [
    {label: 'info', value: 'information-circle-outline'},
    {label: 'retour', value: 'repeat'},
    {label: 'lock', value: 'lock'}
  ];

  constructor(public dataService: DataService) { }

  ngOnInit() {

    this.dataService.get('page').subscribe(items => {
      this.pages = items;
    }, error =>{
      this.pages = [];
      // this.addNewPage();
      console.error(error);
    })

  }
  addNewPage(){
    let np = {...this.new_page};
    this.pages.push(np);
    this.setActivePage(np);
  }

  setActivePage(page: any) {
    this.active_page = page
  }

  savePage(page: any){
    if(!page.id){
      this.dataService.post('page', page).subscribe(result=>{
        this.active_page = result;
        this.active_page.saved = true;
      }, error => {
        console.error(error)
      });
    } else{
      this.dataService.put('page', page).subscribe(result=>{
        this.active_page = result;
        this.active_page.saved = true;
      }, error => {
        console.error(error)
      });
    }

  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/pages/pages.component.ts